import { IDiagnosticTemplate } from "apps/project-iq/models/IDiagnosticTemplate";

export interface IEditSurveyTemplateDialogProps {
  open: boolean;
  template: IDiagnosticTemplate | null;
  onSave: () => void;
  onDismiss: () => void;
}

export const SURVEY_TEMPLATE_CATEGORIES = [
  "Change Management",
  "Agile & Product",
  "PMO & PPM",
  "Technology & Digital",
  "Life Sciences",
] as const;
